import React from 'react';

import { ChangeEmailConfirm } from 'src/components/userEmailChangeRequest';
import {
  UserEmailConfirmRequestErrorModal,
  UserEmailConfirmRequestFulfilledModal,
} from 'src/modals/userEmailConfirmRequest';

export const ChangeEmailConfirmPage: React.FC = () => {
  return (
    <React.Fragment>
      <ChangeEmailConfirm />
      <UserEmailConfirmRequestFulfilledModal />
      <UserEmailConfirmRequestErrorModal />
    </React.Fragment>
  );
};
